import React from "react";
import { useSelector } from "react-redux";

import { TestPageWeb } from "@lt-web-platform/test-page-web";

const TestPageWrapper = ({ pageType }) => {
  // Replace mapStateToProps with useSelector
  const featureFlags = useSelector(state => state.userInfo.featureFlags.data);
  const userInfo = useSelector(state => state.userInfo.userInfo);
  const orgPreferences = useSelector(state => state.orgPreferencesReducer?.orgPreferences);

  // Webpack 5: Use __REACT_APP_ENV__ which is a real iterable object
  // (injected by DefinePlugin - see config/env.js)
  // eslint-disable-next-line no-undef
  const envs = typeof __REACT_APP_ENV__ !== "undefined" ? __REACT_APP_ENV__ : (window?._env_ || {});
  
  return (
    <TestPageWeb
      featureFlags={featureFlags}
      userInfo={userInfo}
      env={envs}
      pageType={pageType}
      orgPreferences={orgPreferences}
    />
  );
};

export default TestPageWrapper;
